module.exports = __webpack_public_path__ + "static/media/resend-invite-2.894b0d99.svg";